import React, { useEffect, useState, type FormEvent } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { DialogContentText, DialogTitle } from '@mui/material';

export type ConfirmDeleteEntriesDialogV2Props = {
	open: boolean;
	/** Number of root entries the user chose to delete (must be ≥ 2 for this dialog). */
	count: number;
	onClose: () => void;
	onConfirm: () => void;
};

/**
 * Bulk delete confirmation: no per-entry labels, only a count — for multi-select flows
 * where loading titles for many items would be noisy.
 */
export default function ConfirmDeleteEntriesDialogV2({
	open,
	count,
	onClose,
	onConfirm,
}: ConfirmDeleteEntriesDialogV2Props) {
	const onSubmit = (e: FormEvent) => {
		e.preventDefault();
		onConfirm();
	};
	const [cachedCount, setCachedCount] = useState(count);
	useEffect(() => {
		if (count) {
			setCachedCount(count);
		}
	}, [count]);
	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: { minWidth: 320 },
			}}
		>
			<DialogTitle>Remove {cachedCount} items?</DialogTitle>
			<form onSubmit={onSubmit} autoComplete="off">
				<DialogContent>
					<DialogContentText>
						These items will be removed from the canvas. This cannot be undone.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>Cancel</Button>
					<Button type="submit" variant="contained" color="error">
						Delete
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}
